import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import db, { doc, updateDoc, serverTimestamp } from '../firebase/firestore';
import { LANGUAGE_STORAGE_KEY, SUPPORTED_LANGUAGES } from '../i18n';

// Reads/writes the active UI language. Signed-in users get their choice
// persisted to their Firestore user doc (users/{uid}.language) — same
// updateDoc-then-refreshProfile shape as StaffPhotoUpload.jsx — so it
// follows them across devices; everyone (signed in or not) also gets an
// instant localStorage mirror so the next page load doesn't flash English
// while the Firestore profile is still loading.
export function useLanguage() {
  const { i18n } = useTranslation();
  const { user, refreshProfile } = useAuth();

  const setLanguage = useCallback(
    (lang) => {
      if (!SUPPORTED_LANGUAGES.includes(lang)) return;
      i18n.changeLanguage(lang);
      try {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
      } catch {
        // localStorage unavailable — in-memory language change still applies
      }
      if (user) {
        updateDoc(doc(db, 'users', user.uid), { language: lang, updatedAt: serverTimestamp() })
          .then(refreshProfile)
          .catch(() => {});
      }
    },
    [i18n, user, refreshProfile]
  );

  return { language: i18n.language, setLanguage };
}
